<template>
  <nav class="navbar">
    <router-link to="/">
      <img class="nav__logo" src="@/assets/images/logo.svg" alt="Logo Greenpeace" />
    </router-link>

    <div class="font-icon">
      <div
        v-if="regularFont"
        title="Czcionka średnia"
        @click="toggleMiddleFontView()"
      >
        <img
          src="@/assets/images/icons/font_plus.svg"
          alt="Czcionka średnia ikona"
        />
      </div>

      <div v-if="middleFont" title="Czcionka duża" @click="toggleBigFontView()">
        <img src="@/assets/images/icons/font_plus.svg" alt="Czcionka duża ikona" />
      </div>

      <div
        v-if="bigFont"
        title="Czcionka domyślna"
        @click="toggleRegularFontView()"
      >
        <img
          src="@/assets/images/icons/font_minus.svg"
          alt="Czcionka domyślna ikona"
        />
      </div>
    </div>
    <div
      class=" contrast-icon"
      title="Kontrast żółto-czarny"
      @click="toggleShowContrast()"
    >
      <img
        src="@/assets/images/icons/font-contrast.svg"
        alt="Kontrast żółto-czarny ikona"
        class="mb-1"
      />
    </div>
  </nav>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      title: "Navigacja",
      regularFont: true,
      middleFont: false,
      bigFont: false,
    };
  },
  components: {},

  methods: {
    scrollToElement(id) {
      let positionOfElement = document.getElementById(id).offsetTop;
      if (window.innerWidth < 1200) {
        window.scroll({
          top: positionOfElement + 575,
          left: 0,
          behavior: "smooth",
        });
      } else {
        window.scroll({
          top: positionOfElement,
          left: 0,
          behavior: "smooth",
        });
      }
    },

    toggleShowContrast() {
      this.$emit("show-contrast-view");
    },
    toggleRegularFontView() {
      this.$emit("show-regular-font-view");
      this.regularFont = true;
      this.middleFont = false;
      this.bigFont = false;
    },
    toggleMiddleFontView() {
      this.$emit("show-middle-font-view");
      this.regularFont = false;
      this.middleFont = true;
      this.bigFont = false;
    },
    toggleBigFontView() {
      this.$emit("show-big-font-view");
      this.regularFont = false;
      this.middleFont = false;
      this.bigFont = true;
    },
  },
};
</script>
<style lang="scss">
.font-icon,
.contrast-icon {
  display: none;
  @media (min-width: 1200px) {
    display: block;
    color: #FF6436;
    background-color: #f5f5f5;
    position: fixed;
    left: 0;
    z-index: 999;
    width: 2.4rem;
    font-size: 1.35rem;
    padding: 0.25rem 0.35rem;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  &:hover {
    cursor: pointer;
  }
  a {
    color: #FF6436;
  }
  a:active,
  a:visited {
    cursor: pointer;
    color: #FF6436;
  }
}
.font-icon {
  top: calc(90vh - 10rem);
}
.contrast-icon {
  top: calc(90vh - 7rem);
}
</style>
